import * as React from "react"

const PageTitle = ({ title }) => {
  return (
    <div className={"relative max-w-6xl mx-auto px-4 md:px-6 py-16"}>
      <h1 className={"text-4xl text-center mb-0"}>{title}</h1>
    </div>
  )
}

export default PageTitle
